// import { ReactComponent as Logo } from './NotFound.svg';

import { MicrospecSvgIcon } from "../../../Components"

const NotFoundSvg = () => {
    return <MicrospecSvgIcon
        src="/static/microspec/images/not-found.svg"
        alt="Not Found"
        style={{ width: "100%", height: "50vh" }}
    />
}

export default NotFoundSvg